import { css } from '@/styled-system/css';

export const priceDropBadgeWrapperStyles = css({
  display: 'inline-block',
  // Override TooltipV2's focus styles
  '& [data-testid="price-drop-badge-tooltip"]:focus': {
    outlineWidth: '0 !important',
    outlineStyle: 'none !important',
    outlineOffset: 'initial',
  },
});

export const getPriceDropBadgeStyles = (variant: 'hdp' | 'srp' = 'hdp') => {
  if (variant === 'srp') {
    // SRP variant: matches getInfoBadgeCX styling from ListingCardV3
    return css({
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: 'hpxRed400', // #c93a1a - Price drop red color
      color: '#FFFFFF',
      fontSize: '12px',
      lineHeight: '16px',
      fontWeight: '600',
      paddingTop: '2px',
      paddingRight: '8px',
      paddingBottom: '1px',
      paddingLeft: '8px',
      borderRadius: '48px', // Pill shape
      cursor: 'pointer',
      whiteSpace: 'nowrap',
      // Custom focus ring for better accessibility
      '&:focus': {
        outlineWidth: '2px !important',
        outlineStyle: 'solid !important',
        outlineColor: '#0066CC !important',
        outlineOffset: '2px !important',
      },
      _focus: {
        outlineWidth: '2px !important',
        outlineStyle: 'solid !important',
        outlineColor: '#0066CC !important',
        outlineOffset: '2px !important',
      },
    });
  }

  // HDP variant: teal arrow icon
  return css({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    marginLeft: '4px', // Space between price and arrow
    // Arrow icon styling
    '& img': {
      width: '12px',
      height: '12px',
      display: 'block',
      alignSelf: 'center',
      transform: 'translateY(1px)', // Fine-tune vertical centering
    },
    // Custom focus ring for better accessibility
    '&:focus': {
      outlineWidth: '2px !important',
      outlineStyle: 'solid !important',
      outlineColor: '#0066CC !important',
      outlineOffset: '2px !important',
    },
    _focus: {
      outlineWidth: '2px !important',
      outlineStyle: 'solid !important',
      outlineColor: '#0066CC !important',
      outlineOffset: '2px !important',
    },
  });
};

// Legacy export for backwards compatibility
export const priceDropBadgeStyles = getPriceDropBadgeStyles('hdp');

// New styles for price drop layout
export const priceWithDropStyles = css({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
});

export const currentPriceStyles = css({
  display: 'flex',
  alignItems: 'center',
  fontSize: 'inherit',
  fontWeight: 'inherit',
  color: 'inherit',
});

export const previousPriceStyles = css({
  fontSize: '12px',
  fontWeight: '400',
  color: 'hpxBlue500',
  textDecoration: 'line-through',
});
